export enum SimTypeEnum {
  physical = 0,
  eSim = 1,
  alterPhysical = 1,
  alterESim = -1,
}
